import { Component, OnInit } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@Component({
    selector: 'formly-spinner',
    template: `
    <mat-spinner
        class="example-margin"
        [color]="'primary'"
        [mode]="'indeterminate'">
    </mat-spinner>
    `,
    styles:[`.example-margin {display:flex; align-content:center; align-items:center; height:60px; }`],
    standalone: true,
    imports: [FormlyModule, MatProgressSpinnerModule]
})
export class SpinnerTypeComponent extends FieldWrapper{


}
